import { render, staticRenderFns } from "./fjxxzy_sqjs.vue?vue&type=template&id=42cd8d4f&scoped=true&"
import script from "./fjxxzy_sqjs.vue?vue&type=script&lang=js&"
export * from "./fjxxzy_sqjs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cd8d4f",
  null
  
)

export default component.exports